import * as yup from 'yup'

export const updateApiKeySchema = yup.object().shape({
    enabled: yup.boolean().required('Заполните это поле'),
    // Три партнёрских scope независимы и по умолчанию выключены; сервер
    // принимает только значения из контракта провайдера.
    adminAuditRead: yup.boolean().required(),
    iamAdminsRead: yup.boolean().required(),
    partnerEventsRead: yup.boolean().required()
})
